/**
 * 訪談附件檔名搜尋 schema — REQ-20260419010。
 * GET /api/v1/attachments/search?q=<keyword>
 */
import { z } from 'zod';

export const AttachmentSearchQuerySchema = z.object({
  q: z.string().trim().min(1).max(100),
});
export type AttachmentSearchQuery = z.infer<typeof AttachmentSearchQuerySchema>;

export const AttachmentSearchHitSchema = z.object({
  id: z.number().int(),
  uuid: z.string().uuid(),
  originalName: z.string(),
  sizeBytes: z.number().int(),
  mimeType: z.string(),
  createdAt: z.string().datetime(),
  customerId: z.number().int(),
  customerCCode: z.string().nullable(),
  customerSimpleName: z.string(),
  interviewId: z.number().int(),
  interviewVisitedAt: z.string().datetime().nullable(),
  interviewTypeName: z.string().nullable(),
});
export type AttachmentSearchHit = z.infer<typeof AttachmentSearchHitSchema>;

export const AttachmentSearchResponseSchema = z.object({
  data: z.array(AttachmentSearchHitSchema),
  meta: z.object({
    total: z.number().int(),
    hasMore: z.boolean(),
  }),
});
export type AttachmentSearchResponse = z.infer<typeof AttachmentSearchResponseSchema>;
